import { getWsBasePath } from "@packages/chat-sdk";

// TODO 修改
/** app 下载地址 */
export const KrakenAppApkDownloadUrl =
  "https://actstatic.insnail.com/damselfish/kraken/apk/qas%E5%B0%8F%E7%BA%A2%E4%B9%A6%E8%84%9A%E6%9C%AC_v1.0.0.apk";

/** exe 下载地址 */
export const KrakenDesktopExeDownloadUrl =
  "https://actstatic.insnail.com/damselfish/kraken/exe/12times%E6%89%A7%E8%A1%8C%E5%99%A8-3.1.3-setup.exe";

/** 说明文档地址 */
export const KrakenReferenceDocumentUrl =
  "https://xiaohongshu-zhu-shou-z0xv81b.gamma.site/";

export enum UserType {
  MAIN = "MAIN",
  RAM = "RAM",
}

export enum ResponseCode {
  Success = 200,
  /** 订单无需支付 */
  OrderNoNeedPay = 201,
  /** 机器人过期 */
  RobotExpired = 450,
  /** 动能值不足 */
  Poweroff = 534,
  /** 模板过期 */
  TemplateExpired = 535,
  /** 定制机器人联系客服购买 */
  NeedBuyViaContactCustomerService = 102,
  /** 机器人需要生成知识库 */
  NeedGenerateKnowledge = 106,
  /** 会话不存在 */
  ConversationNotFound = 310,
}

/** 角色编码 也可能为空 */
export enum RoleCodeEnum {
  /** 管理员 */
  admin = "admin",
  /** 团队组长 */
  "teamLeader" = "teamLeader",
  /** 普通成员 */
  worker = "worker",
}

export const roleNames = {
  [RoleCodeEnum.admin]: "管理员",
  [RoleCodeEnum.teamLeader]: "团队组长",
  [RoleCodeEnum.worker]: "普通成员",
} as Record<RoleCodeEnum, string>;

export const storageKey = {
  /** 伸缩框位置 */
  DRAG_AREA_KEY: "dragAreaKey",
  /** 侧边栏收起和展开状态 */
  SIDEBAR_SPREAD_STATUS: "sidebar_spread_status",
  /** 持久化store的key */
  DAMSELFISH_STORAGE: "damselfish_storage",
  WECOM_CHAT_STORAGE: "wecom_chat_storage",
  MAIL_CHAT_STORAGE: "mail_chat_storage",
  WECOM_CONTACTS_STORAGE: "wecom_contacts_storage",
  WECHAT_CHAT_STORAGE: "wechat_chat_storage",
  WECHAT_CONTACTS_STORAGE: "wechat_contacts_storage",
  MAIL_CONTACTS_STORAGE: "mail_contacts_storage",
  WHATSAPP_CHAT_STORAGE: "whatsapp_chat_storage",
  WHATSAPP_CONTACTS_STORAGE: "whatsapp_contacts_storage",
  /** 知识库列表宽度 */
  DRAG_AREA_KEY_KNOWLEDGE_BASE_LIST_WIDTH: "knowledge_base_list_width",
  /** 新手提示 */
  NOVICE_GUIDE_STORAGE: "novice_guide_storage",
  /** 是否初次导入名片 */
  IS_FIRST_IMPORT_BUSINESS_CARD: "is_first_import_business_card",
  /** 自动发送问候邮件提示 */
  AUTO_SEND_EMAIL_TIP: "auto_send_email_tip",
};

export const TOKEN = "damselfish-token";

export const routerPath = {
  /** 免登录会话 */
  CHAT: "/chat",
  /** WhatsApp 连接 */
  WHATSAPP_CONNECT: "/whatsapp/connect",
  /** WhatsApp 已连接 */
  WHATSAPP_CONNECTED: "/whatsapp/connected",
  /** 403 */
  ERROR_403: "/403",
  /** 404 */
  ERROR_404: "/404",
  /** 首页 */
  HOME: "/home",
  /** 渠道账号管理 */
  CHANNEL_ACCOUNT_LIST:
    "/channel-chat/channel-account-management/channel-account-list",
  /** 添加渠道账号 */
  ADD_CHANNEL_ACCOUNT:
    "/channel-chat/channel-account-management/add-channel-account",
  /** 默认机器人配置 */
  DEFAULT_AI_ROBOT_SETTING:
    "/channel-chat/channel-account-management/default-ai-robot-settings",
  /** 批量托管管理 */
  ESCROW_MANAGEMENT:
    "/channel-chat/channel-account-management/escrow-management",
  /** 渠道会话/渠道会话列表 */
  CHANNEL_CHAT_LIST: "/channel-chat/channel-chat-list",
  /** 渠道会话/渠道会话列表/企业微信聊天 */
  CHANNEL_CHAT_LIST_WECOM_CHAT: "/channel-chat/channel-chat-list/wecom/chat",
  /** 渠道会话/渠道会话列表/企业微信通讯录 */
  CHANNEL_CUSTOMER_LIST_WECOM_CONTACTS:
    "/channel-chat/channel-customer-list/wecom/contacts",
  /** 渠道会话/渠道会话列表/微信聊天 */
  CHANNEL_CHAT_LIST_WECHAT_CHAT: "/channel-chat/channel-chat-list/wechat/chat",
  /** 渠道会话/渠道会话列表/邮箱 */
  CHANNEL_CHAT_LIST_MAIL_CHAT: "/channel-chat/channel-chat-list/mail/chat",
  /** 渠道会话/渠道会话列表/微信通讯录 */
  CHANNEL_CUSTOMER_LIST_WECHAT_CONTACTS:
    "/channel-chat/channel-customer-list/wechat/contacts",
  /** 渠道会话/渠道会话列表/邮箱通讯录 */
  CHANNEL_CUSTOMER_LIST_MAIL_CONTACTS:
    "/channel-chat/channel-customer-list/mail/contacts",
  /** 渠道会话/渠道会话列表/WhatsApp聊天 */
  CHANNEL_CHAT_LIST_WHATSAPP_CHAT:
    "/channel-chat/channel-chat-list/whatsapp/chat",
  /** 渠道会话/渠道会话列表/WhatsApp通讯录 */
  CHANNEL_CUSTOMER_LIST_WHATSAPP_CONTACTS:
    "/channel-chat/channel-customer-list/whatsapp/contacts",
  /** 渠道会话/渠道联系人列表 */
  CHANNEL_CUSTOMER_LIST: "/channel-chat/channel-customer-list",
  /** 资源管理 */
  RESOURCE_MY: "/resource/my",
  /** 资源管理/订单 */
  RESOURCE_ORDER: "/resource/order",
  /** 训练记录 */
  ROBOT_TRAINING_CHAT: "/robot/training-chat",
  /** 创建运营任务 */
  CREATE_OPERATIAL_TASK: "/operation/operational-task/create",
  /** 编辑运营任务 */
  EDIT_OPERATIAL_TASK: "/operation/operational-task/edit",
  /** 运营任务日志记录 */
  OPERATIAL_TASK_LOGS: "/operation/operational-task/logs",
  /** 运营任务日志记录详情 */
  OPERATIAL_TASK_LOG: "/operation/operational-task/log",
  /** 运营SOP编排 */
  OPERATIONAL_SOP_WORKFLOW: "/operation/sop/workflow",
  /** 运营SOP日志记录 */
  OPERATIONAL_SOP_LOGS: "/operation/sop/logs",
  /** 新建团队 */
  CREATE_CHANNEL_TEAM:
    "/channel-chat/channel-account-management/create-channel-team",
  /** 编辑团队 */
  EDIT_CHANNEL_TEAM:
    "/channel-chat/channel-account-management/edit-channel-team",
  /** 标签管理 */
  MANAGE_TAGS: "/customer-management/tag",
  /** 通知 */
  NOTIFICATION: "/notification",
  /** 未读消息 */
  UNREAD_CONVERSATION_LIST: "/channel-chat/unread-conversation-list",
  /** 客户列表 */
  CUSTOMER_LIST: "/customer-management/customer-list",
  /** 客户群列表 */
  CUSTOMER_BASE: "/customer-management/customer-base-management",
  /** 用户中心 */
  USER_CENTER: "/user-center",
  /** 支付宝支付 */
  ALIPAY: "/alipay",
  /** 训练对话 */
  TRAINING_CHAT_CONVERSATION: "/robot/training-chat/conversation",
  /** 训练对话/知识 */
  TRAINING_CHAT_KNOWLEDGE: "/robot/training-chat/knowledge",
  /** 训练对话/素材 */
  TRAINING_CHAT_MATERIAL: "/robot/training-chat/material",
  /** 套餐付费 */
  PRICING: "/pricing",
};

export enum events {
  notification = "notification",
  robot = "robot",
  batchAddTags = "batchAddTags",
}

export const AliPayId = "ALIPAY_PAY_ID";

/** 通用的字数限制 */
export const wordLimit = {
  /** 名称 */
  name: 50,
  /** 描述 */
  description: 150,
};

export const ROBOT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/robot`;

/** 中国大陆手机号正则 */
export const phoneRegex = /^(?:0|86|\+86)?1[3-9]\d{9}$/;
/**  邮箱规则校验 */
export const emailRegex =
  /^(?:[a-za-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$/;

export const defaultAllowPaths: string[] = [
  routerPath.ERROR_403,
  routerPath.ERROR_404,
  routerPath.CHAT,
  routerPath.NOTIFICATION,
  routerPath.USER_CENTER,
  routerPath.UNREAD_CONVERSATION_LIST,
  routerPath.ALIPAY,
  routerPath.PRICING,
  routerPath.WHATSAPP_CONNECT,
  routerPath.WHATSAPP_CONNECTED,
];
